import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-event-copyright',
  templateUrl: './event-copyright.component.html',
  styleUrls: ['./event-copyright.component.scss']
})
export class EventCopyrightComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
